import {
  AdminScaleChildResponse,
  AdminScaleId,
  AdminScaleChildId,
  AdminScaleResponse,
  TreeNode,
  AdminScaleChildType,
  AdminScaleChildPolicyResponse,
} from '@business/entities/adminscale';
import { Endpoint } from '../endpoint';

export function fetchAdminScaleChilds(adminScaleId: AdminScaleId, isCompact?: boolean) {
  return Endpoint.get<AdminScaleChildResponse[]>(`@makh/adminscale-childs`, { params: { adminScaleId, isCompact } });
}

export function fetchAdminScaleChild(id: AdminScaleChildId) {
  return Endpoint.get<AdminScaleChildResponse>(`@makh/adminscale-childs/adminscale/${id}`);
}

export function searchPolicy(search: string) {
  return Endpoint.get<AdminScaleChildPolicyResponse[]>(`@makh/adminscale-childs/search-policy`, { params: { search } });
}

export function searchStatistics(search: string) {
  return Endpoint.get<AdminScaleChildPolicyResponse[]>(`@makh/adminscale-childs/search-statistics`, { params: { search } });
}

export function createAdminScaleChild(data: Partial<AdminScaleResponse>) {
  return Endpoint.post<TreeNode[]>(`@makh/adminscale-childs`, { data });
}

export function updateAdminScaleChild(adminScaleId: AdminScaleChildId, data: Partial<AdminScaleChildResponse>) {
  return Endpoint.patch<TreeNode[]>(`@makh/adminscale-childs/${adminScaleId}`, { data });
}

export function deleteAdminScaleChild(adminScaleId: AdminScaleChildId) {
  return Endpoint.delete<void>(`@makh/adminscale-childs/${adminScaleId}`);
}

export function sortAdminScale(
  adminScaleChild: AdminScaleChildResponse,
  adminScaleId: AdminScaleId,
  toColumnId: number,
  toPosition: number,
  fromColumnId: number,
) {
  return Endpoint.post<AdminScaleChildResponse[]>(`@makh/adminscale-childs/sort-adminscales`, {
    data: { adminScaleChild, adminScaleId, toColumnId, toPosition, fromColumnId },
  });
}
